import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Button,
  InputAdornment,
  FormGroup,
  FormControlLabel,
  Avatar,
  Typography,
  Box,
  CircularProgress,
  Paper,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Chip,
  Autocomplete,
  MenuItem,
} from "@mui/material";
import { motion } from "framer-motion";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import SaveIcon from "@mui/icons-material/Save";
import UpdateIcon from "@mui/icons-material/Update";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import Swal from "sweetalert2";
import configServ from "../../services/config";
import { useSelector } from "react-redux";
import IOSSwitch from "../../Components/Buttons/IOSSwitch";
import AddCircleIcon from "@mui/icons-material/AddCircle";

// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Edit, Delete, RemoveRedEyeOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import LoaderBackdrop from "../../Components/Loader/LoaderBackdrop";
import PhotoPop from "./PhotoPop";
const Photography = () => {
  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const { company_id, user_id } = useSelector((state) => state.GlobalVariables);
  const [backDrowLoading, setBackDrowLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const category_id = 6;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const [mainImage, setMainImage] = useState(null);
  const [images, setImages] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    podcaster_id: null,
    podcast_url: "",
    // url: "",
    active: true,
    // mainImage: "",
    about_photography: "",
  });

  // 🔹 Convert file to Base64 (reusable)
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  // 🔹 Main image upload (next to title)
  const handleMainImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 1024 * 1024) {
      alert("Main image must be less than 1MB");
      return;
    }

    const base64 = await toBase64(file);
    setMainImage(base64);
    setFormData((prev) => ({ ...prev, main_photo: base64 }));
  };

  // 🔹 Multiple images upload (already there, just with delete support)
  const handleImageUpload = async (e) => {
    const files = Array.from(e.target.files);
    const newImages = [];

    for (let file of files) {
      if (file.size > 5 * 1024 * 1024) {
        alert(`${file.name} exceeds 5MB limit.`);
        continue;
      }
      const base64 = await toBase64(file);
      newImages.push(base64);
    }

    const updated = [...images, ...newImages].slice(0, 10);
    setImages(updated);
    setFormData((prev) => ({ ...prev, photos: updated }));
  };

  // 🔹 Delete one image
  const handleDeleteImage = (index) => {
    const updated = images.filter((_, i) => i !== index);
    setImages(updated);
    setFormData((prev) => ({ ...prev, photos: updated }));
  };

  const [previewImage, setPreviewImage] = useState(null);
  const [isPodcasterName, setIsPodcasterName] = useState(false);
  const [podcastList, setPodcastList] = useState([]);
  const [podcastUser, setPodcastUser] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [searchField, setSearchField] = useState("name"); // default search by name
  const handlePopup = () => {
    setIsCreate(!isCreate);
    setIsEdit(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Remove validation error for that specific field when user types
    setValidationErrors((prev) => ({ ...prev, [name]: "" }));
  };

  // Image Upload + Base64 Conversion
  // const handleImageUpload = (e) => {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   if (file.size > 1024 * 1024) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "File too large",
  //       text: "Image size must be less than 1MB",
  //     });
  //     return;
  //   }

  //   const reader = new FileReader();
  //   reader.onloadend = () => {
  //     setPreviewImage(reader.result);
  //     setFormData((prev) => ({ ...prev, image_base64: reader.result }));
  //   };
  //   reader.readAsDataURL(file);
  // };

  const clear = () => {
    setFormData({
      name: "",
      podcaster_id: null,
      podcast_url: "",
      active: true,
      // mainImage: "",
      about_photography: "",
    });

    setIsEdit(false);
    setValidationErrors({});
    setImages([]);
    setMainImage(null);
  };

  // API Call to check podcaster name

  const handleSubmit = async () => {
    const errors = {};

    // Name required
    if (!formData.name?.trim()) {
      errors.name = "Name is required";
    }

    // Podcaster required
    if (!formData.podcaster_id) {
      errors.podcaster_id = "Podcaster is required";
    }

    // if (!mainImage) {
    //   errors.mainImage = "thubnail is required";
    // }

    // URL required & format check
    if (!formData.podcast_url?.trim()) {
      errors.podcast_url = "Photographer URL is required";
    } else {
      // Simple regex for URL validation
      const urlPattern = /^(https?:\/\/)([^\s$.?#].[^\s]*)$/i;
      if (!urlPattern.test(formData.podcast_url.trim())) {
        errors.podcast_url =
          "Enter a valid URL (must start with http:// or https://)";
      }
    }

    // If there are errors, set and stop submit
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    setValidationErrors({});

    try {
      let res;
      if (isEdit) {
        res = await configServ.updateResourceDetails(formData.id, {
          ...formData,
          company_id,
          category_id: category_id,
          updated_by: user_id,
        });
      } else {
        res = await configServ.createResoureceDetails({
          ...formData,
          company_id,
          category_id,
          created_by: user_id,
        });
      }

      if (res.success) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text:
            res.message ||
            (isEdit ? "Numerolog updated!" : "Numerolog created!"),
          timer: 2000,
          showConfirmButton: false,
        });
        clear();
        setIsCreate(false);
        fetchPodcasts();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Something went wrong!",
      });
    }
  };

  const onEdit = async (item) => {
    console.log("onEdit=", item);
    setIsCreate(true);
    setIsEdit(true);

    // 🔹 Step 1: Base formData set
    setFormData({
      ...item,
      podcaster_id: item.resource_id ? parseInt(item.resource_id, 10) : null, // string → int
      // mainImage: item.main_photo || "",
      podcast_url: item.url || "",
      url: item.web_url || "",
      active: item.active === 1 ? true : false,
      photos: [], // ensure default empty
    });

    // 🔹 Step 2: Set main image (for preview)
    if (item.main_photo) {
      setMainImage(item.main_photo);
    }

    try {
      // 🔹 Step 2: Fetch images from API
      const res = await configServ.getPhotographyImagesByResourceId({
        id: item.id,
      });

      if (res?.success && Array.isArray(res.data)) {
        // Extract only base64 strings (each object may have { id, resource_id, image, ... })
        const base64Images = res.data
          .map((img) => img.image)
          .filter((img) => !!img); // only valid images

        // 🔹 Step 3: Update both states
        setImages(base64Images);
        setFormData((prev) => ({
          ...prev,
          photos: base64Images,
        }));
      }
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };

  const fetchPodcasts = async () => {
    try {
      setLoading(true);
      const res = await configServ.getPodcastsByCompanyandCatergory({
        company_id: company_id,
        category_id: category_id,
      });
      if (res.success) {
        setPodcastList(res.data);
      } else {
        console.error("Failed to fetch podcasts:", res.data.message);
      }
    } catch (error) {
      console.error("API error:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchPodcastUser = async () => {
    try {
      setBackDrowLoading(true);
      const res = await configServ.getResourceMasterUserByCompany(company_id);
      if (res.success) {
        setPodcastUser(res.data); // make sure you have state: const [podcastList, setPodcastList] = useState([]);
      } else {
        console.error("Failed to fetch podcasts:", res.data.message);
      }
    } catch (error) {
      console.error("API error:", error);
    } finally {
      setBackDrowLoading(false);
    }
  };
  useEffect(() => {
    if (isCreate) {
      fetchPodcastUser();
    }
  }, [isCreate]);

  // 🔹 useEffect only calls the function
  useEffect(() => {
    if (company_id) {
      fetchPodcasts();
    }
  }, [company_id]);
  const highlightMatch = (text, query) => {
    try {
      const words = query.toLowerCase().split(" ").filter(Boolean);
      const regex = new RegExp(`(${words.join("|")})`, "gi");

      return text.split(regex).map((part, index) =>
        words.includes(part.toLowerCase()) ? (
          <mark key={index} style={{ backgroundColor: "#ffe58f" }}>
            {part}
          </mark>
        ) : (
          <React.Fragment key={index}>{part}</React.Fragment>
        )
      );
    } catch (e) {
      console.error("Error in highlightMatch:", e);
      return text;
    }
  };

  // Inside your component
  const handleDelete = (id, data) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete the podcast.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        configServ
          .deleteResourceDetails(id, data)
          .then((res) => {
            if (res.success) {
              Swal.fire({
                icon: "success",
                title: "Deleted!",
                text: res.message || "Podcast has been deleted.",
                timer: 2000,
                showConfirmButton: false,
              });
              fetchPodcasts();
            }
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: err.response?.data?.message || "Failed to delete podcast.",
            });
          });
      }
    });
  };

  const [openImagePop, setOpenImagePop] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);

  const handleOpenPopup = (productId) => {
    setSelectedProductId(productId);
    setOpenImagePop(true);
  };

  return (
    <>
      <PhotoPop
        open={openImagePop}
        onClose={() => setOpenImagePop(false)}
        productId={selectedProductId}
        fetchImages={configServ.getPhotographyImagesByResourceId}
      />
      <LoaderBackdrop open={backDrowLoading} />
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Photography"}
        handlePopup={handlePopup}
        create={isCreate}
        isEdit={isEdit}
      />

      {isCreate && (
        <motion.div
          style={{
            width: "100%",
            backgroundColor: "#e3f3fc",
            padding: 20,
            borderRadius: "10px",
          }}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.1, delay: 0.1 }}
        >
          <Grid container spacing={2}>
            {/* 🟩 Row 1: Name + Main Image + Podcaster */}
            <Grid item xs={12} md={12}>
              <Grid container spacing={2} alignItems="center">
                {/* Name + Main Image */}
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Photo Title"
                    name="name"
                    onChange={handleChange}
                    value={formData.name || ""}
                    sx={{ backgroundColor: "white" }}
                    error={!!validationErrors.name}
                    helperText={validationErrors.name}
                  />
                </Grid>

                {/* Podcaster Name */}
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    disablePortal
                    fullWidth
                    size="small"
                    id="podcaster_id"
                    name="podcaster_id"
                    options={podcastUser}
                    getOptionLabel={(option) => option.name || ""}
                    filterOptions={(options, { inputValue }) => {
                      const words = inputValue
                        .toLowerCase()
                        .split(" ")
                        .filter(Boolean);
                      return options.filter((user) =>
                        words.every((word) =>
                          user.name.toLowerCase().includes(word)
                        )
                      );
                    }}
                    sx={{ background: "white" }}
                    value={
                      podcastUser.find(
                        (user) => user.id === formData.podcaster_id
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      if (newValue) {
                        setFormData((prev) => ({
                          ...prev,
                          podcaster_id: newValue.id,
                          url: newValue.web_url || "",
                        }));
                      }
                    }}
                    renderInput={(params) => {
                      const inputValue = params.inputProps.value || "";
                      const doesNotMatchOption =
                        inputValue &&
                        !podcastUser.some((user) =>
                          inputValue
                            .toLowerCase()
                            .split(" ")
                            .filter(Boolean)
                            .every((word) =>
                              user.name.toLowerCase().includes(word)
                            )
                        );

                      return (
                        <Box display="flex" alignItems="center" width="100%">
                          <TextField
                            {...params}
                            label="Photographer Name"
                            name="podcaster_id"
                            onChange={(e) => handleChange(e)}
                            error={!!validationErrors.podcaster_id}
                            fullWidth
                          />
                          {doesNotMatchOption && (
                            <IconButton
                              color="primary"
                              onClick={() =>
                                navigate("/transaction-entry/resource-master")
                              }
                            >
                              <AddCircleIcon />
                            </IconButton>
                          )}
                        </Box>
                      );
                    }}
                    renderOption={(props, option, { inputValue }) => (
                      <li {...props}>
                        <Typography variant="body2">
                          {highlightMatch(option?.name, inputValue)}
                        </Typography>
                      </li>
                    )}
                  />
                </Grid>

                <Grid item xs={12} md={5}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Photographer Url"
                    name="podcast_url"
                    onChange={handleChange}
                    value={formData.podcast_url || ""}
                    sx={{ backgroundColor: "white" }}
                    error={!!validationErrors.podcast_url}
                    helperText={validationErrors.podcast_url}
                  />
                </Grid>

                {/* <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Url"
                    name="url"
                    onChange={handleChange}
                    value={formData.url || ""}
                    sx={{ backgroundColor: "white" }}
                    error={!!validationErrors.url}
                    helperText={validationErrors.url}
                    disabled // 👈 ye add karna hai
                  />
                </Grid> */}
                <Grid item xs={12} md={5}>
                  <TextField
                    fullWidth
                    size="small"
                    label="About"
                    name="about_photography"
                    onChange={handleChange}
                    value={formData.about_photography || ""}
                    sx={{ backgroundColor: "white" }}
                    error={!!validationErrors.about_photography}
                    helperText={validationErrors.about_photography}
                    multiline
                    minRows={3} // 👈 gives multi-line text area
                  />
                </Grid>

                {/* <Grid item xs={12} md={2}>
                  <Box textAlign="center">
                    ✅ Label above the upload box
                    <Typography
                      variant="subtitle2"
                      sx={{ mb: 1, fontWeight: 600, color: "text.primary" }}
                    >
                      Thumbnail Upload
                    </Typography>
                    {mainImage ? (
                      <Box position="relative" display="inline-block">
                        <img
                          src={mainImage}
                          alt="Main"
                          width={90}
                          height={90}
                          style={{
                            borderRadius: "8px",
                            objectFit: "cover",
                            border: "1px solid #ccc",
                          }}
                        />
                        <IconButton
                          size="small"
                          color="error"
                          sx={{
                            position: "absolute",
                            top: -10,
                            right: -10,
                            background: "white",
                          }}
                          onClick={() => {
                            setMainImage(null);
                            setFormData((prev) => ({
                              ...prev,
                              main_photo: null,
                            }));
                          }}
                        >
                          ✕
                        </IconButton>
                      </Box>
                    ) : (
                      <>
                        <Button
                          variant="outlined"
                          component="label"
                          sx={{
                            width: 90,
                            height: 90,
                            borderRadius: 2,
                            borderColor: validationErrors.mainImage
                              ? "error.main"
                              : "grey.400",
                          }}
                        >
                          +
                          <input
                            type="file"
                            accept="image/*"
                            hidden
                            onChange={handleMainImageUpload}
                          />
                        </Button>

                        🔹 Show validation error below upload box
                        {validationErrors.mainImage && (
                          <Typography
                            variant="caption"
                            color="error"
                            display="block"
                            sx={{ mt: 0.5 }}
                          >
                            {validationErrors.mainImage}
                          </Typography>
                        )}
                      </>
                    )}
                  </Box>
                </Grid> */}
              </Grid>
            </Grid>

            {/* 🟨 Row 2: Upload Photos */}
            {/* <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                Upload Photos (max 10)
              </Typography>

              <Box display="flex" flexWrap="wrap" gap={2}>
                {images.map((img, idx) => (
                  <Box key={idx} position="relative">
                    <img
                      src={img}
                      alt={`upload-${idx}`}
                      width={100}
                      height={100}
                      style={{
                        borderRadius: 8,
                        objectFit: "cover",
                        border: "1px solid #ccc",
                      }}
                    />
                    <IconButton
                      size="small"
                      color="error"
                      sx={{
                        position: "absolute",
                        top: -10,
                        right: -10,
                        background: "white",
                      }}
                      onClick={() => handleDeleteImage(idx)}
                    >
                      ✕
                    </IconButton>
                  </Box>
                ))}

                {images.length < 10 && (
                  <Button
                    variant="outlined"
                    component="label"
                    sx={{ width: 100, height: 100, borderRadius: 2 }}
                  >
                    +
                    <input
                      type="file"
                      accept="image/*"
                      hidden
                      multiple
                      onChange={handleImageUpload}
                    />
                  </Button>
                )}
              </Box>
            </Grid> */}

            {/* 🟦 Row 3: Active Status */}
            <Grid item xs={12} md={3}>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <IOSSwitch
                      checked={formData.active}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          active: e.target.checked,
                        }))
                      }
                      name="active"
                    />
                  }
                  label="Active"
                />
              </FormGroup>
            </Grid>
          </Grid>

          {/* Buttons */}
          <Grid container spacing={2} justifyContent="flex-end" mt={2}>
            <Grid item>
              <Button
                onClick={clear}
                variant="contained"
                color="secondary"
                startIcon={<RotateLeftIcon />}
              >
                Reset
              </Button>
            </Grid>
            <Grid item>
              <Button
                onClick={handleSubmit}
                variant="contained"
                color={isEdit ? "success" : "primary"}
                startIcon={isEdit ? <UpdateIcon /> : <SaveIcon />}
              >
                {isEdit ? "Update" : "Save"}
              </Button>
            </Grid>
          </Grid>
        </motion.div>
      )}

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mt: 2,
          width: "100%",
          gap: 1,
          ml: "5",
        }}
      >
        <TextField
          select
          size="small"
          value={searchField}
          onChange={(e) => setSearchField(e.target.value)}
          sx={{ minWidth: 120, backgroundColor: "white" }}
        >
          <MenuItem value="name">Title</MenuItem>
        </TextField>

        <TextField
          size="small"
          placeholder={`Search by ${searchField}...`}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={{ width: 250, backgroundColor: "white" }}
        />
      </Box>

      {/* 🔹 Mobile Card View */}
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : podcastList.length === 0 ? (
        <Box sx={{ textAlign: "center", mt: 4, color: "text.secondary" }}>
          No podcasts found
        </Box>
      ) : (
        <>
          {/* 🔹 Mobile Card View */}
          <Box
            sx={{
              mt: 2,
              width: "100%",
              display: { xs: "block", sm: "none" },
            }}
          >
            <Grid container spacing={2}>
              {podcastList
                .filter((item) => {
                  const value = (item[searchField] || "")
                    .toString()
                    .toLowerCase();
                  return value.includes(searchQuery.toLowerCase());
                })
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((podcast, index) => (
                  <Grid item xs={12} key={podcast.id}>
                    <Paper
                      elevation={3}
                      sx={{
                        p: 2,
                        borderRadius: 3,
                        backgroundColor: "#fff",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <Box display="flex" gap={2} alignItems="flex-start">
                        {/* Thumbnail */}
                        {/* <Box
                          sx={{
                            width: 70,
                            height: 70,
                            borderRadius: 2,
                            overflow: "hidden",
                            flexShrink: 0,
                            border: "1px solid #ddd",
                          }}
                        >
                          {podcast.main_photo ? (
                            <img
                              src={podcast.main_photo}
                              alt={podcast.name}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <Box
                              sx={{
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "#f5f5f5",
                                color: "#888",
                                fontSize: 12,
                              }}
                            >
                              No Image
                            </Box>
                          )}
                        </Box> */}

                        {/* Details */}
                        <Box flexGrow={1}>
                          <Typography variant="subtitle1" fontWeight="600">
                            {podcast.name}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ mt: 0.5 }}
                          >
                            Photographer:{" "}
                            <strong>{podcast.podcaster_name || "N/A"}</strong>
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                              mt: 0.5,
                              wordBreak: "break-word",
                              overflowWrap: "anywhere",
                            }}
                          >
                            Photographer Url:{" "}
                            <strong>{podcast.url || "N/A"}</strong>
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                              mt: 0.5,
                              wordBreak: "break-word",
                              overflowWrap: "anywhere",
                            }}
                          >
                            About Photo:{" "}
                            <strong>
                              {podcast.about_photography || "N/A"}
                            </strong>
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ mt: 0.5 }}
                          >
                            Date:{" "}
                            {new Date(podcast.created_at).toLocaleDateString(
                              "en-IN"
                            )}
                          </Typography>

                          <Chip
                            label={podcast.active ? "Active" : "Inactive"}
                            color={podcast.active ? "success" : "default"}
                            size="small"
                            sx={{ mt: 1 }}
                          />
                        </Box>
                      </Box>

                      {/* Actions */}
                      <Box
                        display="flex"
                        justifyContent="flex-end"
                        gap={1.5}
                        sx={{ mt: 2 }}
                      >
                        <IconButton
                          color="primary"
                          onClick={() => onEdit(podcast)}
                          size="small"
                        >
                          <Edit fontSize="small" />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() => handleDelete(podcast.id, podcast)}
                          size="small"
                        >
                          <Delete fontSize="small" />
                        </IconButton>
                        {/* <IconButton
                          sx={{ color: "green" }}
                          onClick={() => handleOpenPopup(podcast.id)}
                          size="small"
                        >
                          <RemoveRedEyeOutlined fontSize="small" />
                        </IconButton> */}
                      </Box>
                    </Paper>
                  </Grid>
                ))}
            </Grid>

            {/* Pagination (Optional for mobile too) */}
            <TablePagination
              component="div"
              count={podcastList.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Box>

          {/* 🔹 Desktop Table View */}
          <Box
            sx={{ mt: 2, width: "100%", display: { xs: "none", sm: "block" } }}
          >
            <TableContainer component={Paper}>
              <Table>
                <TableHead sx={{ backgroundColor: "#1976d2" }}>
                  <TableRow>
                    <TableCell sx={{ color: "#fff" }}>S.No.</TableCell>
                    <TableCell sx={{ color: "#fff" }}>
                      Photographer Name
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }}>Photo Title</TableCell>
                    <TableCell sx={{ color: "#fff" }}>
                      Photographer URL
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }}>Status</TableCell>
                    <TableCell sx={{ color: "#fff" }}>Date</TableCell>
                    <TableCell sx={{ color: "#fff" }}>About Photo</TableCell>

                    <TableCell sx={{ color: "#fff" }} align="right">
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {podcastList
                    .filter((item) => {
                      const value = (item[searchField] || "")
                        .toString()
                        .toLowerCase();
                      return value.includes(searchQuery.toLowerCase());
                    })
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((podcast, index) => (
                      <TableRow key={podcast.id}>
                        <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                        <TableCell>{podcast.podcaster_name}</TableCell>

                        <TableCell>{podcast.name}</TableCell>
                        <TableCell>
                          <Typography
                            sx={{
                              display: "-webkit-box",
                              WebkitLineClamp: 2, // <-- number of lines
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                            }}
                          >
                            {podcast.url}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          <Chip
                            label={podcast.active ? "Active" : "Inactive"}
                            color={podcast.active ? "success" : "default"}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          {new Date(podcast.created_at).toLocaleString(
                            "en-IN",
                            {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              // hour: "2-digit",
                              // minute: "2-digit",
                            }
                          )}
                        </TableCell>
                        {/* <TableCell>
                          {podcast.main_photo && (
                            <img
                              src={podcast.main_photo}
                              alt={podcast.name}
                              style={{
                                width: 50,
                                height: 50,
                                borderRadius: "8px",
                                objectFit: "cover",
                                border: "1px solid #ccc",
                              }}
                            />
                          )}
                        </TableCell> */}
                        <TableCell
                          sx={{
                            display: "-webkit-box",
                            WebkitLineClamp: 2, // <-- number of lines
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                          }}
                        >
                          {podcast.about_photography}
                        </TableCell>

                        <TableCell align="right">
                          <IconButton
                            color="primary"
                            onClick={() => onEdit(podcast)}
                          >
                            <Edit fontSize="small" />
                          </IconButton>
                          <IconButton color="error">
                            <Delete
                              fontSize="small"
                              onClick={() => handleDelete(podcast.id, podcast)}
                            />
                          </IconButton>
                          {/* <IconButton sx={{ color: "green" }}>
                            <RemoveRedEyeOutlined
                              fontSize="small"
                              onClick={() => handleOpenPopup(podcast.id)}
                            />
                          </IconButton> */}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
              <TablePagination
                component="div"
                count={podcastList.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableContainer>
          </Box>
        </>
      )}
    </>
  );
};

export default Photography;
